import * as React from "react";

import { InitialComputationDto } from "core/backend/data";
import { MultiSelectItem } from "components/multiselect";
import TDatetime from "components/TDatetime";
import CheckIcon from "components/checkIcon";

interface OwnProps {
    dto: InitialComputationDto;
    hubs: MultiSelectItem[];
    left: number;
}

const Row = ({ dto, hubs, left }: OwnProps) =>
    <>
        <tr>
            <TDatetime rowSpan={dto.contingencies.length} date={new Date(dto.dateTimeUtc)} left={left} />
            <td rowSpan={dto.contingencies.length}>{dto.tso}</td>
            <td rowSpan={dto.contingencies.length}>{dto.cneName}</td>
            <td rowSpan={dto.contingencies.length}>{dto.cneEic}</td>
            <td rowSpan={dto.contingencies.length}>{dto.direction}</td>
            <td rowSpan={dto.contingencies.length}>{dto.hubFrom}</td>
            <td rowSpan={dto.contingencies.length}>{dto.hubTo}</td>
            <td rowSpan={dto.contingencies.length}>{dto.substationFrom}</td>
            <td rowSpan={dto.contingencies.length}>{dto.substationTo}</td>
            <td rowSpan={dto.contingencies.length}>{dto.elementType}</td>
            <td rowSpan={dto.contingencies.length}>{dto.fmaxType}</td>

            <td className="lineLeft">{dto.contTso}</td>
            <td>{dto.contName}</td>
            <td>{dto.contingencies[0].branchName}</td>
            <td>{dto.contingencies[0].branchEic}</td>
            <td>{dto.contingencies[0].hubFrom}</td>
            <td>{dto.contingencies[0].hubTo}</td>
            <td>{dto.contingencies[0].substationFrom}</td>
            <td>{dto.contingencies[0].substationTo}</td>
            <td>{dto.contingencies[0].elementType}</td>

            <td rowSpan={dto.contingencies.length} className="lineLeft"><CheckIcon checked={dto.presolved} /></td>
            <td rowSpan={dto.contingencies.length}>{dto.ram}</td>
            <td rowSpan={dto.contingencies.length}>{dto.imax}</td>
            <td rowSpan={dto.contingencies.length}>{dto.u}</td>
            <td rowSpan={dto.contingencies.length}>{dto.fmax}</td>
            <td rowSpan={dto.contingencies.length}>{dto.frm}</td>
            <td rowSpan={dto.contingencies.length}>{dto.frefInit}</td>
            <td rowSpan={dto.contingencies.length}>{dto.fnrao}</td>
            <td rowSpan={dto.contingencies.length}>{dto.fref}</td>
            <td rowSpan={dto.contingencies.length}>{dto.fcore}</td>
            <td rowSpan={dto.contingencies.length}>{dto.fall}</td>
            <td rowSpan={dto.contingencies.length}>{dto.fuaf}</td>
            <td rowSpan={dto.contingencies.length}>{dto.amr}</td>
            <td rowSpan={dto.contingencies.length}>{dto.ltaMargin}</td>
            <td rowSpan={dto.contingencies.length}>{dto.cva}</td>
            <td rowSpan={dto.contingencies.length}>{dto.iva}</td>
            <td rowSpan={dto.contingencies.length}>{dto.ftotalLtn}</td>

            {hubs.map((hub) => <td rowSpan={dto.contingencies.length} key={hub.id}>{eval("dto.ptdf_" + hub.id.toUpperCase())}</td>)}
        </tr>
        {
            dto.contingencies.slice(1).map((c) =>
                <tr key={c.number}>
                    <td colSpan={2} className="alignRight">Additional branch #{c.number}:</td>
                    <td>{c.branchName}</td>
                    <td>{c.branchEic}</td>
                    <td>{c.hubFrom}</td>
                    <td>{c.hubTo}</td>
                    <td>{c.substationFrom}</td>
                    <td>{c.substationTo}</td>
                    <td>{c.elementType}</td>
                </tr>
            )
        }
    </>;

export default Row;